export interface LoyaltyUser {
  runtime: number;
  favouriteRewards: number[];
}

export function emptyLoyaltyUser(): LoyaltyUser {
  return {
    runtime: 0,
    favouriteRewards: [],
  };
}
